<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}">

        <validated-text-area label="About Text*" v-model="model.about_text"
                             :rules="{required: true, max:150}" :disabled="loading"/>

        <validated-text-area label="Text 1*" v-model="model.text_1"
                             :rules="{required: true, max:70}" :disabled="loading"/>

        <validated-text-area label="Text 2*" v-model="model.text_2"
                             :rules="{required: true, max:145}" :disabled="loading"/>

        <validated-file-input class="c-file-input" label="Banner Image*" name="Banner Image" v-model="model.banner_image"
                              :disabled="loading"/>

        <validated-checkbox label="Enabled" v-model="model.is_enabled"
                            :rules="{required: false}" :disabled="loading"/>

        <btn class="trn" size="sm" :loading="loading" color="primary" text="Save"
             loading-text="Saving..." :disabled="loading"/>
    </b-form>
</template>

<script>
import urls from '@/data/cms-urls';

export default {
    name : 'AddAboutUs',

    data () {
        return {
            addUrl : urls.cms.aboutUs.addEdit
        };
    },

    methods : {
        formSuccess () {
            this.$notify('Successfully Added About Us..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
